import React from 'react';

const { $ } = window;

export default class PagesList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      project: props.project,
      pages: props.project.pages
    };
    this.state.project.addEventListener('update-pages page-loaded', () => {
      this.setState({
        pages: this.state.project.pages
      });
    });
  }

  componentDidMount() {
    $('[data-content]').popup();
  }

  componentDidUpdate() {
    $('[data-content]').popup();
  }

  render() {
    let project = this.state.project;

    return (
      <div className="ui mini images" id="pagesList">
        {this.state.pages.map(page => (
          <img key={page.id} className={'ui image' + (project.activePage == page ? ' active' : '')} data-content={page.name} src={page.source.src} onClick={() => project.selectPage(page)} />
        ))}
      </div>
    );
  }
}
